<template>
  <div>
    <q-dialog :visible="isVisible" :title="title" width="86%" :innerScroll="false" :showFooter="false" :loading="loadingBtn" @close="onCancel">
      <div class="content">
        <search-box-dialog class="search-box">
          <el-form :inline="true" size="mini" :model="searchForm" :rules="rules" ref="searchForm">
            <el-form-item label="SPU编码/名称:" prop="spuName">
              <el-input v-model.trim="searchForm.spuName" placeholder="产品名称"></el-input>
            </el-form-item>
            <el-form-item label="商品编码/名称:" prop="goodsCode">
              <el-input v-model="searchForm.goodsCode" placeholder="产品编码"></el-input>
            </el-form-item>
            <el-form-item label="预计上市时间:">
              <form-date-range :form="searchForm" startKey="startTime" endKey="endTime" :usingTime="false" valueFormat="yyyy-MM-dd"></form-date-range>
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
            <el-button class="orange-btn" size="mini" @click="onReset">重置</el-button>
          </template>
        </search-box-dialog>
        <el-row>
          <el-col :span="12">可选择列表</el-col>
          <el-col :span="12" class="right-container">已选择列表</el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-table
              ref="table"
              v-loading="loading"
              element-loading-text="数据加载中"
              element-loading-spinner="el-icon-loading"
              @selection-change="handleSelectionChange"
              :row-key="
                (row) => {
                  return row.goodsCode;
                }
              "
              :header-cell-style="{ backgroundColor: '#F4F8FB' }"
              :data="tableData.records"
              :height="300"
              class="full-width-table"
              border
            >
              <el-table-column type="selection" width="39" :reserve-selection="true"></el-table-column>
              <el-table-column label="SPU编码" prop="spuCode" show-overflow-tooltip min-width="120"></el-table-column>
              <el-table-column label="SPU名称" prop="spuName" show-overflow-tooltip min-width="150"></el-table-column>
              <el-table-column label="商品编码" prop="goodsCode" show-overflow-tooltip min-width="120"></el-table-column>
              <el-table-column label="商品名称" prop="goodsName" show-overflow-tooltip min-width="150"></el-table-column>
              <el-table-column label="预计上市时间" prop="expOnelineTime" show-overflow-tooltip width="105"></el-table-column>
            </el-table>
            <div class="pagination-container" height="auto">
              <el-pagination
                @current-change="downloadHandleCurrentChange"
                :current-page="tableData.pageNum"
                :page-sizes="[30, 100, 500, 1000]"
                :page-size="tableData.pageSize"
                layout="total, prev, pager, next"
                :total="tableData.total"
              ></el-pagination>
            </div>
          </el-col>
          <el-col :span="12" class="right-container">
            <el-table
              element-loading-text="数据加载中"
              element-loading-spinner="el-icon-loading"
              :header-cell-style="{ backgroundColor: '#F4F8FB' }"
              :data="selectSpus"
              :height="300"
              class="full-width-table"
              border
            >
              <el-table-column label="SPU编码" prop="spuCode" show-overflow-tooltip min-width="120"></el-table-column>
              <el-table-column label="SPU名称" prop="spuName" show-overflow-tooltip min-width="150"></el-table-column>
              <el-table-column label="商品编码" prop="goodsCode" show-overflow-tooltip min-width="120"></el-table-column>
              <el-table-column label="商品名称" prop="goodsName" show-overflow-tooltip min-width="150"></el-table-column>
              <el-table-column label="预计上市时间" prop="expOnelineTime" show-overflow-tooltip width="105"></el-table-column>
              <el-table-column label="操作" align="center" width="60" fixed="right">
                <template slot-scope="{ row }">
                  <el-button type="text" class="red-text-btn" @click="delRow(row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <div class="footer-btn">
          <el-button size="mini" @click="onCancel">取消</el-button>
          <el-button class="green-btn" size="mini" @click="onConfirm">添加</el-button>
        </div>
      </div>
    </q-dialog>
  </div>
</template>

<script>
import searchBoxDialog from '../../components/search-box.vue';
export default {
  name: 'CRUDEdit',
  components: {
    searchBoxDialog,
  },
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    listNo: [String, Number],
  },

  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return '添加商品';
    },
  },
  data() {
    return {
      loading: false,
      loadingBtn: false,
      searchForm: {
        spuName: '',
        goodsCode: '',
        startTime: '',
        endTime: '',
        type: 2,
      },
      rules: {},
      tableData: [],
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      selectSpus: [],
      statusList: [],
    };
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    init() {
      this.loading = true;
      let data = {
        filterData: this.searchForm,
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
      };
      this.$q.newProduct
        .spuPage({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          } else {
            this.tableData.records = [];
          }
          this.loading = false;
        })
        .catch((_) => {
          this.loading = false;
        });
    },
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },
    onReset() {
      this.$refs.searchForm.resetFields();
      // this.$refs.table.clearSelection();
      this.onSearch();
    },
    downloadClose() {
      this.$refs.table.clearSelection();
    },
    downloadHandleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
      if (this.statusList.length) {
        this.statusList.forEach((row) => {
          if (
            this.tableData.records.find((item) => {
              return row.productCode == item.productCode;
            })
          ) {
            this.$refs.table.toggleRowSelection(
              this.tableData.records.find((item) => {
                return row.productCode == item.productCode;
              }),
              true
            );
          } else {
            this.$refs.table.toggleRowSelection(row, true);
          }
        });
      }
    },

    delRow(row) {
      // 从右侧表格中删除数据
      this.selectSpus = this.selectSpus.filter((item) => item.goodsCode !== row.goodsCode);

      // 清除左侧表格中被删除行的选中状态
      if (this.$refs.table) {
        const index = this.tableData.records.findIndex((item) => item.goodsCode === row.goodsCode);
        if (index !== -1) {
          this.$refs.table.toggleRowSelection(this.tableData.records[index], false);
        }
      }
    },

    handleSelectionChange(val) {
      this.selectSpus = this.removal(val);
    },
    onConfirm() {
      if (!this.selectSpus.length) {
        this.$message.error('请选择商品！');
        return;
      }
      this.loadingButtom = true;
      let data = {
        listNo: this.listNo,
        spuList: this.selectSpus.map((v) => ({
          skuCode: v.goodsCode,
          spuCode: v.spuCode,
          expecUpDate: v.expOnelineTime
        })),
      };
      this.$q.newProduct
        .appendSpuSku({ data: data })
        .then((res) => {
          this.onCancel();
          this.$message.success('添加成功');
          this.$emit('success');
        })
        .finally((_) => {
          this.loadingButtom = false;
        });
    },

    removal(arrObj) {
      //去重
      let map = new Map();
      for (let item of arrObj) {
        if (!map.has(item.goodsCode)) {
          map.set(item.goodsCode, item);
        }
      }
      return [...map.values()];
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
.content {
  padding-right: 15px;
  max-height: 70vh;
  overflow-y: auto;
}

.radio-container {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  span {
    margin-right: 10px;
  }
}

.search-box {
  margin-bottom: 10px;
}

>>> .date-range .single-date {
  width: 110px !important;
}

>>> .form-number-input .el-input-number {
  width: 105px !important;
}

>>> .form-number-input .el-input-number .el-input {
  width: 105px !important;
}

.full-width-table {
  width: 100%;
}

.pagination-container {
  text-align: right;
  padding-top: 10px;
}

.right-container {
  padding-left: 30px;
  margin: 5px 0;
}

.footer-btn {
  text-align: center;
  margin-top: 10px;
}

>>> .el-dialog {
  margin-top: 50px !important;
}

>>> .dialog-content {
  padding-right: 0 !important;
}

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-thumb {
  height: 45.7326%;
  transform: translateY(0%);
  position: relative;
  display: block;
  cursor: pointer;
  border-radius: inherit;
  border-radius: 10px;
  background-color: rgba(144, 147, 153, 0.3);
  transition: 0.3s background-color;
}
</style>
